<template>
    <v-flex>
        <v-subheader>{{titulo}}</v-subheader>
        <v-row dense v-if="keywords && keywords.length > 0" align="center">
            <v-col cols="1">
                <div class="caption text-right">Filtrar:</div>
            </v-col>
            <v-col>
                <template v-for="(item, index) in keywords">
                    <v-chip :key="item" x-small @click="selectTipoAccion(item)" :color="item == selectedAccion?'info':''" >{{item}}</v-chip>
                </template>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-data-table 
        :headers="headersAcciones"
        :items="listaFiltrada"
        :loading="loading"
        dense
        >
        <template v-slot:no-data>
            <v-alert :value="true"  icon="warning">
                No se encontraron datos
            </v-alert>
        </template>

        <template v-slot:item="{ item }">
            <tr>
            <td  class="text-xs-left caption">{{ item.fecha  | dateParse() | dateFormat('DD-MM-YYYY HH:mm') }}</td>
            <td class="text-xs-left caption">
                <tr>
                    <td class="text-uppercase font-weight-medium caption">
                        {{ item.accion }}
                    </td>  
                </tr>  
                <tr>
                    <td v-if="item.comentarios && item.comentarios != ''" class="font-weight-light caption">
                        {{ item.comentarios }}
                    </td>  
                </tr>  
            </td>
            <td  class="text-xs-left caption">{{ item.responsable }}</td>
            <!-- <td class="text-xs-left caption">{{ item.comentarios }}</td> -->
            </tr>
        </template>
        </v-data-table>
    </v-flex>
</template>
<script>

import Vue from 'vue'
import { format } from 'date-fns'
export default {
    data: () => ({
        headersAcciones: [ // definición de columnas
            { text: 'Fecha', value: 'fecha' , width: 140},
            { text: 'Acción', value: 'accion' },
            { text: 'Responsable', value: 'responsable', width: 90},
            // { text: 'Comentarios', value: 'comentarios', width: 200},
        ],
        selectedAccion: null
    }),
    props:{
        list: {
            type: Array,
        },
        loading: {
            type: Boolean
        },
        titulo: {
            type: String
        }
    },
    computed: {
        keywords: function(){
            if(!this.list) return null;

            // armo una lista con los distintos eventos 
            var cloud = [];

            for (let i = 0; i < this.list.length; i++) {
                const item = this.list[i];
                var accion = item.accion;

                if(!cloud.find(i=>i == accion))
                    cloud.push(accion);
            } 
            
            return cloud;

        },
        listaFiltrada: function(){
            if(!this.list) return [];
            if(this.selectedAccion == null) return this.list;

            var lista = [];
            
            for (let i = 0; i < this.list.length; i++) {
                const item = this.list[i];

                if(item.accion == this.selectedAccion)
                    lista.push(item);
            } 
            return lista;

        }
    },
    methods: {
        selectTipoAccion(tipo){
            if(this.selectedAccion == tipo)
                this.selectedAccion = null;
            else
                this.selectedAccion = tipo;
        }
    }
}
</script>